export const DEFAULT_TRAVEL_TIME = 45;
